import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from "react-router-dom";
import router from "./router.jsx";
import {ContextProvider} from './context/ContextProvider.jsx'
import { ChakraProvider } from '@chakra-ui/react';
// import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <ChakraProvider> 
    <ContextProvider>
     <RouterProvider router={router} />
    </ContextProvider>
  </ChakraProvider> 
  </React.StrictMode>
);
